// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api_host : 'https://admin.turnosanramon.ubq.cl',
  url_api_rut: 'https://fp6h63xvne.execute-api.us-west-2.amazonaws.com/dev/validar?', 
  apikey_api_rut: '5016316d-943c-4e6b-987c-f194e458f1b4', 
  secret_api_rut: '27a06cd2-28b8-45eb-b75f'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
